import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiLoginService } from 'src/app/services/login/api-login.service';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent implements OnInit {

  @Input() show: any = false;
  @Input() message: any = '';
  constructor(
    private apiService: ApiService,
    private apiLogin: ApiLoginService
  ) { }

  ngOnInit(): void {
    this.apiService.errorPopup$.subscribe(param => {
      this.show = param.show
      this.message = param.message
    })
  }

  close(): void{
    
    this.show = false
    this.message = ''

  }

}
